import { HttpError } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { Branch, defaultBranch } from "types/branch";
import React from "react";

import { BranchForm } from "./BranchForm";

export default function EditBranch() {
  const methods = useForm<Branch, HttpError>({
    defaultValues: defaultBranch,
  });

  return (
    <Edit saveButtonProps={methods.saveButtonProps}>
      <BranchForm control={methods.control} createMode={false} />
    </Edit>
  );
}
